module.exports = __webpack_public_path__ + "static/media/info-icon.bc12cb9f.svg";